import { ListApiConfig, ListControls } from '../types/list';

export function buildListParams(
  controls: ListControls,
  config: ListApiConfig
): Record<string, any> {
  const { page, pageSize, search, sort } = controls;
  const {
    defaultSort,
    columns,
    extraStaticParams,
    searchParamKey = 'name',
    searchTransformer,
  } = config;

  const params: Record<string, any> = {
    _limit: pageSize,
    _offset: Math.max(0, (page - 1) * pageSize),
    _order_by: (sort && sort.trim() !== '' ? sort : defaultSort) || undefined,
  };

  if (columns) {
    params._columns = columns;
  }

  if (typeof search === 'string' && search.trim() !== '') {
    const transformed = searchTransformer ? searchTransformer(search) : search;
    params[searchParamKey] = transformed;
  }

  if (extraStaticParams) {
    Object.assign(params, extraStaticParams);
  }

  return params;
}
